import React from 'react';
import { Segment, Button } from 'semantic-ui-react';


// props: success (null, false, true)
export default class AfterPrint extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            successPrint: false,
            loading: true,
            serverResponse: null,
            error: false,
        };
    }
    render() {
        const { success } = this.props;
        return (
            <Segment.Group raised>
                <Segment>
                    {success === false ? <h3> Došlo je do greške!</h3>
                        : success === null ? <h3>  Procesuira se...</h3>
                            : success === true ? <h3>Uspješno izvršeno!</h3>
                                : null}
                </Segment>
                <Segment clearing>
                    <Button color="blue" basic="true" floated="left" onClick={() => this.props.changeWizardStep('prev')}>Nazad</Button>
                    <Button color="blue" floated="right" onClick={() => this.props.changeWizardStep('next')}>Vrati se na početak</Button>
                </Segment>
            </Segment.Group>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/DegreeDocumentPrint/AfterPrint.js